import { render, staticRenderFns } from "./ProductsPublicRetailer.vue?vue&type=template&id=70bf1a3e&"
import script from "./ProductsPublicRetailer.vue?vue&type=script&lang=js&"
export * from "./ProductsPublicRetailer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports